export default function mkKey() {
  return Math.random().toString(36).slice(2, 10)
}
